import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { AdminGuard } from './core/guards/admin.guard';

export const routes: Routes = [
  // Auth (public)
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES),
  },
  // Dashboard (protected)
  {
    path: 'dashboard',
    loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [AuthGuard],
  },
  // Admin (protected + admin)
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.routes').then(m => m.ADMIN_ROUTES),
    canActivate: [AuthGuard, AdminGuard],
  },
  // Profile (protected)
  {
    path: 'profile',
    loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [AuthGuard],
  },
  // Fleet / Vessel 360 (protected)
  {
    path: 'fleet',
    loadComponent: () => import('./features/fleet/fleet.component').then(m => m.FleetComponent),
    canActivate: [AuthGuard],
  },
  // SSO launch handler
  {
    path: 'sso/launch/:appKey',
    loadComponent: () => import('./features/dashboard/sso-launch.component').then(m => m.SsoLaunchComponent),
    canActivate: [AuthGuard],
  },
  // Default
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: '**', redirectTo: 'auth/login' },
];
